import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import _find from 'underscore/modules/find';
import BeneficiaryCardReportsSection from './BeneficiaryCardReportsSection';
import SpendingSettingsSdkContainer from 'react/member/card/components/spending_monitor_tab/SpendingSettingsSdkContainer';
import CardholderTransactionList from 'react/shared/card/components/cardholder_dashboard/CardholderTransactionList';
import SubSectionHeader from 'react/shared/components/SubSectionHeader';
import TrueLinkBanner from 'react/shared/components/true_link/lab/TrueLinkBanner';
function BeneficiaryDashboardCardTab(props) {
  if (!props.account) {
    return <div />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [displaySdkView, setDisplaySdkView] = useState($tlf.flipperEnableSpendingSettingsSdkToggle);

  const handleChange = (event) => {
    setDisplaySdkView(event.target.checked);
  };

  // card_balance loads from javascripts in client/dashboard/home.html.haml
  return (
    <div>
      <div className="widescreen-inner-container">
        <h3 className="current-balance-header">
          <div className="pull-right">Status: {props.account.card_humanized_status}</div>
          Current Balance: &nbsp;
          <div className="card_balance" />
          &nbsp;
          <small>
            <br />
            card ending in {props.account.card_last_four}
          </small>
        </h3>
        <ul id="cardholder_home_menu">
          <li>
            <a href="#recent_transactions">This Month's Transactions</a>
          </li>
          <li>
            <a href="#transaction_report">Transaction Report</a>
          </li>
          <li>
            <a href="#monthly_statements">Monthly Statements</a>
          </li>
          <li>
            <a href="#card_settings">Card Settings</a>
          </li>
        </ul>
      </div>
      <div>
        <SubSectionHeader id="recent_transactions">This Month's Transactions</SubSectionHeader>
        <div style={{ marginTop: 20, width: '100%' }}>
          <CardholderTransactionList additionalClassNames="" nightlyPosts={props.transactions} />
        </div>
      </div>
      <BeneficiaryCardReportsSection
        account={_find(
          // competing notions of account serialization
          props.trustBeneficiary.accounts,
          (acct) => acct.id === props.account.account_id,
        )}
      />
      {$tlf.flipperEnableSpendingSettingsSdkToggle && (
        <div style={{ marginTop: 50 }}>
          <TrueLinkBanner
            dismissible
            text={
              'Our improved navigation makes updating settings easier. The settings on your True Link Cards have not changed, we’re just displaying them to you in a new format. For a limited time, you can return to the classic experience in the toggle below.'
            }
            title={'Our Spending Settings have been updated!'}
            variant="promo"
          />
          <Grid
            alignItems="center"
            container
            direction="row"
            justifyContent="flex-end"
            sx={{ p: 2 }}
          >
            <div>Viewing Updated Experience</div>
            <Switch checked={displaySdkView} onChange={handleChange} />
          </Grid>
        </div>
      )}
      {/* Disabling since this was done before we agreed on JSON and APIs */}
      {/* eslint-disable-next-line react/no-danger */}
      {!displaySdkView && <div dangerouslySetInnerHTML={{ __html: props.cardSettings }} />}
      {displaySdkView && (
        <SpendingSettingsSdkContainer accountId={`${props.account.account_id}`} canEdit={false} />
      )}
    </div>
  );
}

export default BeneficiaryDashboardCardTab;

BeneficiaryDashboardCardTab.propTypes = {
  trustBeneficiary: PropTypes.object.isRequired,
  account: PropTypes.object,
  cardSettings: PropTypes.node,
  transactions: PropTypes.array,
};
